
class ConnectionProductService {

    srv: any
    constructor(srv: any) {
        this.srv = srv;   
    }

    //set server ready for connection process handling
    initConnectionProducts() : any {
        var deferred = jQuery.Deferred();

        this.srv.getAvailableAndExistingProducts().done(function (data) {
            deferred.resolve(true);
        }).fail(function () {
            deferred.resolve(false);
        });

        return deferred;
    }

    setSelectedConnectionProductType(isSelected: boolean, type: number) {
        var deferred = jQuery.Deferred();

        this.srv.setSelectedConnectionProductTypeByType(isSelected, type).done(function (data) {
            deferred.resolve(true);
        }).fail(function () {
            deferred.resolve(false);
        });

        return deferred;
    }

    setSelectedConnectionProductTypeAndSelectFirstProduct(type: number, isSelected: boolean) {
        var deferred = jQuery.Deferred();

        this.srv.setSelectedConnectionProductTypeAndSelectFirstProduct(type, isSelected).done(function (data) {
            deferred.resolve(true);
        }).fail(function () {
            deferred.resolve(false);
        });

        return deferred;
    }

    getConnectionProducts(type: number, customerType: number) {
        var deferred = jQuery.Deferred();

        this.srv.getConnectionProducts(type, customerType).done(function (data) {
            deferred.resolve(data);
        }).fail(function () {
            deferred.resolve(null);
        });

        return deferred;
    }

    getConnectionProductsSorted(type: number, customerType: number) {
        var deferred = jQuery.Deferred();

        this.srv.getConnectionProductsSorted(type, customerType).done(function (data) {
            deferred.resolve(data);
        }).fail(function () {
            deferred.resolve(null);
        });

        return deferred;
    }

    setSelectedConnectionProduct(value: number, isSelected: boolean) {
        var deferred = jQuery.Deferred();

        //action 1 = add, action 0 = remove
        var action = 1;
        if (!isSelected) {
            action = 0;
        }

        this.srv.setSelectedConnectionProduct(value, action).done(function (data) {
            deferred.resolve(data);
        }).fail(function (error) {
            console.log(error);
            deferred.resolve(null);
        });

        return deferred;
    }
}